import { createApp } from 'vue'
import App from './App.vue'
import ConsentSettings from './components/ConsentSettings.vue'
import ConsentButton from './components/ConsentButton.vue'
import ConsentPopup from './components/ConsentPopup.vue'
import ConsentModal from './components/ConsentModal.vue'
import QuickList from './components/QuickList.vue'
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
    locale: window.ampsandCookiesLang || 'de',
    allowComposition: true,
    messages: {
        en: {
            details: 'Details',
            toggle_tracking: 'Toggle tracking',
            close_drawer: 'Close drawer window',
            read_more: 'Read more about the provider\'s cookies',
            identification: 'Identification',
            description: 'Description',
            expiration: 'Expiration',
            cookies_preferences: 'Cookies Preferences',
            cookies_preferences_intro: 'Here you can customize the Cookies Settings in order to reflect your privacy preferences.',
            cookies_preferences_footer: 'You can read more the use we do of Cookies on our',
            privacy_policy: 'Privacy Policy',
            cookies_text: 'We use cookies to give you the best possible website experience. You can read more the use we do of Cookies on our',
            allow: 'Allow All',
            customize: 'Customize Preferences',
            deny: 'Deny'
        },
        de: {
            details: 'Details',
            toggle_tracking: 'Verfolgung einschalten',
            close_drawer: 'Schubladenfenster schließen',
            read_more: 'Lesen Sie mehr über die Cookies des Anbieters',
            identification: 'Identifizierung',
            description: 'Beschreibung',
            expiration: 'Ablauf',
            cookies_preferences: 'Cookies-Einstellungen',
            cookies_preferences_intro: 'Hier können Sie die Cookie-Einstellungen anpassen, um Ihre Datenschutzpräferenzen zu berücksichtigen.',
            cookies_preferences_footer: 'Weitere Informationen über die Verwendung von Cookies finden Sie in unserer',
            privacy_policy: 'Datenschutzrichtlinie',
            cookies_text: 'Wir verwenden Cookies, um Ihnen das bestmögliche Website-Erlebnis zu bieten. Weitere Informationen über die Verwendung von Cookies finden Sie in unserer',
            allow: 'Alle zulassen',
            customize: 'Voreinstellungen anpassen',
            deny: 'Verweigern'
        },
        fr: {
            details: 'Détails',
            toggle_tracking: 'Basculer le suivi',
            close_drawer: 'Fermer la fenêtre du tiroir',
            read_more: 'En savoir plus sur les cookies du fournisseur',
            identification: 'Identification',
            description: 'Description',
            expiration: 'Expiration',
            cookies_preferences: 'Préférences en matière de cookies',
            cookies_preferences_intro: 'Vous pouvez personnaliser ici les paramètres des cookies afin de refléter vos préférences en matière de confidentialité.',
            cookies_preferences_footer: 'Vous pouvez en savoir plus sur l\'utilisation que nous faisons des cookies sur notre',
            privacy_policy: 'politique de confidentialité',
            cookies_text: 'Nous utilisons des cookies pour vous offrir la meilleure expérience possible sur le site web. Vous pouvez en savoir plus sur l\'utilisation que nous faisons des cookies dans notre',
            allow: 'Tout autoriser',
            customize: 'Personnaliser les préférences',
            deny: 'Refuser'
        },
        it: {
            details: 'Dettagli',
            toggle_tracking: 'Attiva il tracciamento',
            close_drawer: 'Chiudi la finestra del cassetto',
            read_more: 'Leggi di più sui cookie del provider',
            identification: 'Identificazione',
            description: 'Descrizione',
            expiration: 'Scadenza',
            cookies_preferences: 'Preferenze cookies',
            cookies_preferences_intro: 'Qui potete personalizzare le impostazioni dei cookie in modo da riflettere le vostre preferenze sulla privacy.',
            cookies_preferences_footer: 'Per saperne di più sull\'uso che facciamo dei cookie, consulta la nostra',
            privacy_policy: 'informativa sulla privacy',
            cookies_text: 'Utilizziamo i cookie per offrirvi la migliore esperienza possibile sul sito web. Per saperne di più sull\'uso che facciamo dei cookie, consultare la nostra',
            allow: 'Consenti tutti',
            customize: 'Personalizza preferenze',
            deny: 'Rifiuta'
        },
    }
})

createApp(App)
    .use(i18n)
    .component('ConsentSettings', ConsentSettings)
    .component('ConsentButton', ConsentButton)
    .component('ConsentPopup', ConsentPopup)
    .component('ConsentModal', ConsentModal)
    .component('QuickList', QuickList)
    .mount('#ampsandConsentElement')

